import {
  Display,
  DisplayBottomWidget,
  DisplayWidget,
  WidgetText
} from './Display';
import { GameTitle } from './GameTitle';
import { Preloader } from './Preloader';
import { SimpleButton } from './SimpleButton';
import { SimpleWindow } from './SimpleWindow';
import { Wrapper } from './Wrapper';

export { SimpleButton } from './SimpleButton';
export { SimpleWindow } from './SimpleWindow';
export { Preloader } from './Preloader';
export { Wrapper } from './Wrapper';
export {
  Display,
  DisplayBottomWidget,
  DisplayWidget,
  WidgetText
} from './Display';

export {
  ACTIONS,
  CanvasApi,
  HSLA,
  GameInput,
  ActionFrame,
  FigureGenerator,
  Grid,
  Game,
  Timer
} from '../index';
export { default as STAGES } from './stages';

export default {
  Wrapper,
  Preloader,
  GameTitle,
  SimpleWindow,
  SimpleButton,
  Display,
  DisplayBottomWidget,
  DisplayWidget,
  WidgetText
};



// WEBPACK FOOTER //
// ./src/components/interface/index.js